import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { OLAF } from 'HubStyleTokens/colors';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import imageUrls from '../../images/imageUrls';
const GuaranteeBannerHeaderContent = styled(FormattedReactMessage).withConfig({
  displayName: "GuaranteeBannerHeader__GuaranteeBannerHeaderContent",
  componentId: "sc-1ipmk87-0"
})(["color:", ";font-size:22px;position:relative;"], OLAF);
export const GuaranteeBannerHeader = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIImage, {
      className: "m-top-10",
      height: "110",
      src: imageUrls.successCheckmark
    }), /*#__PURE__*/_jsx(GuaranteeBannerHeaderContent, {
      className: "m-top-5",
      message: 'guaranteeBanner.header',
      options: {
        hubspotLogo: /*#__PURE__*/_jsx(UIImage, {
          alt: "HubSpot Logo",
          className: "m-bottom-3",
          height: 40,
          responsive: false,
          src: imageUrls.hubspotLogo,
          width: 160
        })
      }
    })]
  });
};